<div class="step-1" *ngIf="step == 'step-1'">
  <div class="text-center mb-5">
    <h3>{{'CRYPTO.SELECT_YOUR_CRYPTO_CURRENCY_DEPOSIT_METHOD' | translate}}</h3>
  </div>
  <div class="d-flex justify-content-center align-items-center">
    <div class="trc20 mr-4 crypto-box" (click)="selectCryptoType('trc20')">
      <img src="../../../../assets/crypto/tether.png" alt="" style="width: 4rem">
      <img src="../../../../assets/crypto/trc20.png" alt="" style="width: 4rem">
    </div>
    <div class="erc20 mr-4 crypto-box" (click)="selectCryptoType('erc20')">
      <img src="../../../../assets/crypto/tether.png" alt="" style="width:4rem">
      <img src="../../../../assets/crypto/erc20.png" alt="" style="width: 4rem">
    </div>
    <div class="btc mr-4 crypto-box" (click)="selectCryptoType('btc')">
      <img src="../../../../assets/crypto/btc.png" alt="" style="width: 4rem">
    </div>
    <div class="ether crypto-box" (click)="selectCryptoType('ether')">
      <img src="../../../../assets/crypto/erc20.png" alt="" style="width: 4rem">
    </div>
  </div>
</div>

<div class="my-2" *ngIf="cryptoType">
  <div class="column-center" *ngIf="cryptoType=='trc20'">
    <div class="crypto-box">
      <img src="../../../../assets/crypto/tether.png" alt="" style="width: 4rem">
      <img src="../../../../assets/crypto/trc20.png" alt="" style="width: 4rem">
    </div>
  </div>
  <div class="column-center" *ngIf="cryptoType=='erc20'">
    <div class="crypto-box">
      <img src="../../../../assets/crypto/tether.png" alt="" style="width:4rem">
      <img src="../../../../assets/crypto/erc20.png" alt="" style="width: 4rem">
    </div>
  </div>
  <div class="column-center" *ngIf="cryptoType=='btc'">
    <div class="crypto-box">
      <img src="../../../../assets/crypto/btc.png" alt="" style="width: 4rem">
    </div>
  </div>
  <div class="column-center" *ngIf="cryptoType=='ether'">
    <div class="crypto-box">
      <img src="../../../../assets/crypto/erc20.png" alt="" style="width: 4rem">
    </div>
  </div>
</div>

<div class="step-2 m-4" *ngIf="step == 'step-2'">
  <div class="my-2" style="font-size: 1.2rem;" *ngIf="cryptoType">

    <div *ngIf="cryptoType=='trc20'">
      <div>
        <li><span class="danger-clr">{{'CRYPTO.ONLY_SEND_TETHER_USDT' | translate}}</span> {{'CRYPTO.TO_THIS_DEPOSIT_ADDRESS' | translate}}.</li>
        <li><span class="danger-clr">{{'CRYPTO.DO_NOT_USE' | translate}}</span> {{'CRYPTO.DO_NOT_USE_ERC20' | translate}}.</li>
        <li><span class="danger-clr">{{'CRYPTO.ONLY_MAKE_DEPOSITS_THROUGH_THE_TRON_TRC20_NETWORK' | translate}}</span></li>
        <li><span class="danger-clr">{{'CRYPTO.THE_USE_OF_CONTRACT_ADDRESSES_IS_NOT_ALLOWED' | translate}}.</span></li>
        <div style="margin-top: 2rem;font-weight: bold;">
          {{'CRYPTO.RISKS_CONFIRMATION' | translate}}
        </div>
      </div>
    </div>

    <div *ngIf="cryptoType=='erc20'">
      <div>
        <li><span class="danger-clr">{{'CRYPTO.ONLY_SEND_TETHER_USDT' | translate}}</span> {{'CRYPTO.TO_THIS_DEPOSIT_ADDRESS' | translate}}.</li>
        <li><span class="danger-clr">{{'CRYPTO.DO_NOT_USE' | translate}}</span> {{'CRYPTO.DO_NOT_USE_BEP2_BEP20_OMNI_TRC20_SOL' | translate}}.</li>
        <li><span class="danger-clr">{{'CRYPTO.ONLY_MAKE_DEPOSITS_THROUGH_THE_ETHEREUM_NETWORK_ERC20' | translate}}</span></li>
        <li><span class="danger-clr">{{'CRYPTO.THE_USE_OF_CONTRACT_ADDRESSES_IS_NOT_ALLOWED' | translate}}.</span></li>
        <div style="margin-top: 2rem;font-weight: bold;">
          {{'CRYPTO.RISKS_CONFIRMATION' | translate}}
        </div>
      </div>
    </div>

    <div *ngIf="cryptoType=='ether'">
      <div>
        <li><span class="danger-clr">{{'CRYPTO.ONLY_SEND_ETHEREUM_METH' | translate}}</span> {{'CRYPTO.TO_THIS_DEPOSIT_ADDRESS' | translate}}.</li>
        <li><span class="danger-clr">{{'CRYPTO.DO_NOT_USE' | translate}}</span> {{'CRYPTO.DO_NOT_USE_BEP2_BEP20' | translate}}.</li>
        <li><span class="danger-clr">{{'CRYPTO.ONLY_MAKE_DEPOSITS_THROUGH_THE_ETHEREUM_NETWORK' | translate}}</span></li>
        <li><span class="danger-clr">{{'CRYPTO.THE_USE_OF_CONTRACT_ADDRESSES_IS_NOT_ALLOWED' | translate}}.</span></li>
        <div style="margin-top: 2rem;font-weight: bold;">
          {{'CRYPTO.RISKS_CONFIRMATION' | translate}}
        </div>
      </div>
    </div>

    <div *ngIf="cryptoType=='btc'">
      <div>
        <li><span class="danger-clr">{{'CRYPTO.ONLY_SEND_BITCOIN_MICRONBTC' | translate}}</span> {{'CRYPTO.TO_THIS_DEPOSIT_ADDRESS' | translate}}.</li>
        <li><span class="danger-clr">{{'CRYPTO.DO_NOT_USE' | translate}}</span> {{'CRYPTO.DO_NOT_USE_LIGHTNING_NETWORK' | translate}}.</li>
        <li><span class="danger-clr">{{'CRYPTO.ONLY_MAKE_DEPOSITS_THROUGH_THE_BTC_NETWORK' | translate}}</span></li>
        <li><span class="danger-clr">{{'CRYPTO.THE_USE_OF_CONTRACT_ADDRESSES_IS_NOT_ALLOWED' | translate}}</span></li>
        <div style="margin-top: 2rem;font-weight: bold;">
          {{'CRYPTO.RISKS_CONFIRMATION' | translate}}
        </div>
      </div>
    </div>

  </div>

  <button class="w-100 btn btn-success" (click)="confirm()">
    Confirm
  </button>
</div>

<div class="step-3 m-4" *ngIf="step == 'step-3'">
  <h5>1 USDT = 0.34545353534 MAD</h5>
  <h5>{{'CRYPTO.COPY_ADDRESS_OR_SCAN_QR_CODE' | translate}}</h5>
  <h5 style="color: red;">ASD2WADAD3WDASDSAD2SADA
    <i class="pi pi-copy" [cdkCopyToClipboard]="'ASD2WADAD3WDASDSAD2SADA'"
      style="font-size: 1.5rem;color:rgb(81, 121, 19); cursor:pointer"></i>
  </h5>
  <div class="column-center my-3">
    <qrcode [qrdata]="'ASD2WADAD3WDASDSAD2SADA'" [width]="300"></qrcode>
    <!-- [bc-width]="1" [bc-height]="50" -->
  </div>
  <p class="rule-box">
    <li>{{'CRYPTO.MINIMUM_DEPOSIT_AMOUNT' | translate: { amount: 10.00 } }}</li>
    <li>{{'CRYPTO.NOTE_ABOUT_THE_EXCHANGE_RATE' | translate}}</li>
    <li>{{'CRYPTO.TRANSACTION_COMPLETION' | translate}}</li>
  </p>
</div>